import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * Global drawer for "Request a Quote" requests.
 *
 * Any component that has a "Request Quote" affordance (BulkBuy card, PDP
 * for large-qty inquiries, Consultation upsell, etc.) calls `openQuote()`
 * and optionally pre-fills product / quantity context so the shopper
 * doesn't have to re-type what they were looking at.
 */

const QuoteDrawerContext = createContext(null);

const EMPTY_PREFILL = {
  product: "",
  category: "",
  quantity: "",
};

export function QuoteDrawerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState(EMPTY_PREFILL);

  const openQuote = useCallback((next = {}) => {
    setPrefill({ ...EMPTY_PREFILL, ...next });
    setOpen(true);
  }, []);

  const closeQuote = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <QuoteDrawerContext.Provider value={{ open, prefill, openQuote, closeQuote }}>
      {children}
    </QuoteDrawerContext.Provider>
  );
}

export function useQuoteDrawer() {
  const ctx = useContext(QuoteDrawerContext);
  if (!ctx) {
    // Safe default so callers rendered outside the provider don't crash.
    return { open: false, prefill: EMPTY_PREFILL, openQuote: () => {}, closeQuote: () => {} };
  }
  return ctx;
}
